import { date } from "quasar";
const { isValid } = date;

export const isValidDateString = (dateString, separator = "-") => {
  try {
    const [day, month, year] = dateString?.split(separator) || [];

    if (dateString?.length === 10 && day && month && year) {
      return isValid(new Date(year, month, day));
    }
  } catch (error) {
    console.error(error);
  }
};

export const isValidPhoneNumber = (num) => {
  const regexp = /^\d+$/;

  return regexp.test(num) && String(num).length === 10;
};

export const detectSpace = (value) => {
  const regexp = /\s+/g;

  return regexp.test(value);
};

export const isValidGstin = (value) =>
  /^\d{2}[A-Z]{5}\d{4}[A-Z][0-9A-Z]{3}$/.test(value);

export default {
  isValidDateString,
  isValidPhoneNumber,
  detectSpace,
  isValidGstin,
};
